export const normalizeRegistrationLinkKey = value => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const getRegistrationLinkKeyFallback = (registration, index) => {
    const identifier = normalizeRegistrationLinkKey(
        registration?.id || registration?.form?.uuid || registration?.form?._id
    ).slice(0, 8);

    return `registration-${identifier || index + 1}`;
};

export const ensureRegistrationLinkKeys = registrations => {
    const usedKeys = new Set();

    return (Array.isArray(registrations) ? registrations : []).map((registration, index) => {
        const baseKey = normalizeRegistrationLinkKey(registration?.linkKey) ||
            normalizeRegistrationLinkKey(registration?.label) ||
            getRegistrationLinkKeyFallback(registration, index);
        let linkKey = baseKey;
        let suffix = 2;

        while (usedKeys.has(linkKey)) {
            linkKey = `${baseKey}-${suffix}`;
            suffix += 1;
        }

        usedKeys.add(linkKey);
        return {...registration, linkKey};
    });
};

export const buildRegistrationChoiceUrl = (browserState, linkKey) => {
    if (!browserState || !linkKey) return null;

    const params = new URLSearchParams(browserState.search || '');
    params.set('type', normalizeRegistrationLinkKey(linkKey));
    const search = params.toString();

    return `${browserState.pathname || '/'}${search ? `?${search}` : ''}${browserState.hash || ''}`;
};
